<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      size="small"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="this.$l('form_label_deviceId') || '设备编号'"
            prop="deviceId"
          >
            <el-input
              :placeholder="
                $l('tips_input_deviceIdassetCode') || '请输入设备编号...'
              "
              v-model="formData.deviceId"
              maxlength="50"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_assetCode') || '资产编码'"
            prop="assetCode"
          >
            <el-input
              :placeholder="
                $l('tips_input_assetCodeassetCode') || '请输入资产编码...'
              "
              v-model="formData.assetCode"
              maxlength="50"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_assetName') || '资产名称'"
            prop="assetName"
          >
            <el-input
              :placeholder="$l('tips_input_assetName') || '请输入资产名称...'"
              v-model="formData.assetName"
              maxlength="100"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_deviceType') || '设备类型'"
            prop="deviceType"
          >
            <dict-select
              clearable
              v-model="formData.deviceType"
              :placeholder="$l('tips_select_deviceType') || '请选择设备类型...'"
              filterable
              size="small"
              url="/sys/common/dict/system"
              :body="{ dictType: 'deviceType' }"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_specModel') || '规格型号'"
            prop="specModel"
          >
            <el-input
              :placeholder="$l('tips_input_specModel') || '请输入规格型号...'"
              v-model="formData.specModel"
              maxlength="100"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_unit') || '设备单位'"
            prop="unit"
          >
            <dict-select
              clearable
              v-model="formData.unit"
              :placeholder="$l('tips_select_unit') || '请选择设备单位...'"
              filterable
              size="small"
              url="/sys/common/dict/system"
              :body="{ dictType: 'deviceUnit' }"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_manufacturer') || '生产厂商'"
            prop="manufacturer"
          >
            <el-input
              :placeholder="
                $l('tips_input_manufacturer') || '请输入生产厂商...'
              "
              v-model="formData.manufacturer"
              maxlength="255"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_purchaseDate') || '购买日期'"
            prop="purchaseDate"
          >
            <el-date-picker
              v-model="formData.purchaseDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              :placeholder="$l('tips_select_purchaseDate') || '请选择购买日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="this.$l('form_label_remark') || '备注'"
            prop="remark"
          >
            <el-input
              type="textarea"
              :placeholder="$l('tips_input_remark') || '请输入备注...'"
              v-model="formData.remark"
              :rows="2"
              maxlength="500"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div style="font-size: 16px;font-weight: bold;margin: 10px 0;">
            {{ $l('form_label_save_text') || '保管信息' }}
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_storageLocation') || '存放地点'"
            prop="storageLocation"
          >
            <dict-select
              clearable
              v-model="formData.storageLocation"
              :placeholder="
                $l('tips_select_storageLocation') || '请选择存放地点...'
              "
              filterable
              size="small"
              url="/sys/common/dict/system"
              :body="{ dictType: 'storageLocation' }"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_storageAddress') || '存放地址'"
            prop="storageAddress"
          >
            <el-input
              :placeholder="
                $l('tips_input_storageAddress') || '请输入存放地址...'
              "
              v-model="formData.storageAddress"
              maxlength="500"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custodian') || '保管人'"
            prop="custodian"
          >
            <el-input
              :placeholder="$l('tips_input_custodian') || '请输入保管人...'"
              v-model="formData.custodian"
              maxlength="500"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_bookQuantity') || '账存数量'"
            prop="bookQuantity"
          >
            <el-input-number
              v-model="formData.bookQuantity"
              :placeholder="
                $l('tips_input_bookQuantity') || '请输入账存数量...'
              "
              controls-position="right"
              style="width:100%"
              :max="99999999"
              :min="0"
              v-el-inputnumber-default0
              :step="1"
              :precision="0"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_actualQuantity') || '实际数量'"
            prop="actualQuantity"
          >
            <el-input-number
              v-model="formData.actualQuantity"
              :placeholder="
                $l('tips_input_actualQuantity') || '请输入实际数量...'
              "
              controls-position="right"
              style="width:100%"
              :max="99999999"
              :min="0"
              v-el-inputnumber-default0
              :step="1"
              :precision="0"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    deviceCode: String,
  },
  components: {},
  data() {
    return {
      formData: { cancelReason: '', bookQuantity: 0, actualQuantity: 0 },
      reasonVisible: false,
      detailList: [],
      rules: {
        deviceId: [
          {
            required: true,
            message:
              this.$l('tips_input_deviceIdassetCode') || '请输入设备编号...',
            trigger: 'blur',
          },
        ],
        assetCode: [
          {
            required: true,
            message:
              this.$l('tips_input_assetCodeassetCode') || '请输入资产编码...',
            trigger: 'blur',
          },
        ],
        assetName: [
          {
            required: true,
            message: this.$l('tips_input_assetName') || '请输入资产名称...',
            trigger: 'blur',
          },
        ],
        deviceType: [
          {
            required: true,
            message: this.$l('tips_select_deviceType') || '请选择设备类型...',
            trigger: 'change',
          },
        ],
        unit: [
          {
            required: true,
            message: this.$l('tips_select_unit') || '请选择设备单位...',
            trigger: 'change',
          },
        ],
        manufacturer: [
          {
            required: true,
            message: this.$l('tips_select_manufacturer') || '请选择生产厂商...',
            trigger: 'change',
          },
        ],
        purchaseDate: [
          {
            required: true,
            message: this.$l('tips_select_purchaseDate') || '请选择购买日期...',
            trigger: 'change',
          },
        ],
        storageLocation: [
          {
            required: true,
            message:
              this.$l('tips_select_storageLocation') || '请选择存放地点...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.deviceCode) return
      this.loadingOpen()
      this.$api
        .mrpPlDeviceDetailApi({
          deviceCode: this.deviceCode,
        })
        .then((res) => {
          this.loadingClose()
          this.formData = res.body
          this.detailList = res.body.detailList || []
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      this.loadingOpen()
      this.$api
        .mrpPlDeviceSaveApi({
          deviceCode: this.deviceCode,
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.$message({
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success',
            })
            this.$emit('close')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    // saveOkQuestion() {
    //   this.$emit('saveOkQuestion')
    // },
  },
}
</script>
<style lang="scss" scoped>
.aas {
  margin-left: 4%;
}
</style>
